import React from 'react';
const Tab = ({ children }) => React.createElement(React.Fragment, null, children);
export default Tab;
